import { z } from "zod";

import { MetaDataSchema } from "@/schemas/meta-data";

// ── Enums ──

export enum ListPreviewStatus {
	PENDING = "PENDING",
	RUNNING = "RUNNING",
	COMPLETED = "COMPLETED",
	STOPPED = "STOPPED",
	FAILED = "FAILED",
}

export enum PreviewResultStatus {
	FOUND = "FOUND",
	UNSURE = "UNSURE",
	NOT_FOUND = "NOT_FOUND",
	SKIPPED = "SKIPPED",
	COMPANY_DISQUALIFIED = "COMPANY_DISQUALIFIED",
	COMPANY_NOT_FOUND = "COMPANY_NOT_FOUND",
}

export enum PreviewMatchedVia {
	PROFILE_1 = "PROFILE_1",
	PROFILE_2 = "PROFILE_2",
	PROFILE_3 = "PROFILE_3",
	AI = "AI",
	OVERRIDE_RULE = "OVERRIDE_RULE",
}

export enum PreviewRerunMode {
	KEEP_FOUND = "KEEP_FOUND",
	DISCARD_ALL = "DISCARD_ALL",
}

// ── Zod Schemas ──

export const ListPreviewSchema = z.object({
	id: z.number(),
	listId: z.number(),
	status: z.nativeEnum(ListPreviewStatus),
	companyCount: z.number(),
	processedCount: z.number(),
	foundCount: z.number(),
	unsureCount: z.number(),
	notFoundCount: z.number(),
	creditsUsed: z.number(),
	estimatedFullListCredits: z.number().nullable(),
	createdAt: z.string(),
});

export const ListPreviewResultSchema = z.object({
	id: z.number(),
	organizationName: z.string(),
	organizationLogo: z.string().nullable(),
	organizationSize: z.string().nullable(),
	personName: z.string().nullable(),
	personTitle: z.string().nullable(),
	personAvatar: z.string().nullable(),
	personImage: z.string().nullable(),
	linkedinUrl: z.string().nullable(),
	matchedVia: z.nativeEnum(PreviewMatchedVia).nullable(),
	status: z.nativeEnum(PreviewResultStatus).nullable(),
	statusReason: z.string().nullable(),
	order: z.number(),
});

export const ListPreviewResultsResponseSchema = z.object({
	data: z.array(ListPreviewResultSchema),
	meta: MetaDataSchema,
});

// ── TypeScript Types ──

export type ListPreview = z.infer<typeof ListPreviewSchema>;
export type ListPreviewResult = z.infer<typeof ListPreviewResultSchema>;
export type ListPreviewResultsResponse = z.infer<typeof ListPreviewResultsResponseSchema>;

// ── Request Types ──

export interface StartPreviewRequest {
	companyCount: 10 | 20 | 50;
}

export interface RerunPreviewRequest {
	mode: PreviewRerunMode;
}

export interface ExtendPreviewRequest {
	additionalCount: 10 | 20 | 50;
}
